import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";

export const requestGetAdvisers = async () => {
    const [result, err] = await doRequest(
        "/AsesorPsicologo", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listAsesorPsicologo.map(({
        codigoPsicologo: code,
        nombrePsicologo: name
    }) => {
        return {
            code, 
            name
        };
    });
}